import {
  GET_BANKING_ALERTS_PENDING,
  GET_BANKING_ALERTS_FULFILLED,
  GET_BANKING_ALERTS_FAILED,
  UPDATE_DELIVERY_CHANNEL,
  BANKING_ALERTS_ERROR,
  BANKING_ALERTS_FULFILLED,
  BANKING_ALERTS_PENDING
} from "../actionTypes";
import AppHelper from "../../helpers/appHelper";
import ActionCreator from "../../helpers/apiRequestor";
import { BANKING_ALERTGROUPS_ENDPOINT, DELIVERY_CHANNELS_CONFIG } from "../../helpers/apiUrls";
import { HttpType } from "../../helpers/constantValues";
import Axios from "axios";

export const getDeliveryChannels = () => (dispatch) => {

  dispatch({ type: BANKING_ALERTS_PENDING })
  Axios.get(AppHelper.getMiddlewareApiUrl(DELIVERY_CHANNELS_CONFIG), { headers: AppHelper.getSessionTokenHeaders() }).then(response => {
    dispatch({
      type: UPDATE_DELIVERY_CHANNEL,
      deliveryChannels: response.data
    })
    dispatch({ type: BANKING_ALERTS_FULFILLED })
  })
    .catch(
      dispatch({ type: BANKING_ALERTS_ERROR })
    )
}
export const bankingAlerts = () => {
  
  return (dispatch) => dispatch(ActionCreator(
    {
      url: AppHelper.getMiddlewareApiUrl(BANKING_ALERTGROUPS_ENDPOINT),
      method: HttpType.GET,
      headers: AppHelper.getSessionTokenHeaders(),
    },
    GET_BANKING_ALERTS_PENDING,
    GET_BANKING_ALERTS_FULFILLED,
    GET_BANKING_ALERTS_FAILED
  ));
};
